import core, { App, GQL } from '@gin-betting/core';

const { appServiceLocator } = core;

export default function getMatchesByIds(
    variables: GQL.GetMatchesByIdsQueryVariables
): Promise<App.TypedFetchResult<GQL.GetMatchesByIdsQuery>> {
    const apiClient = appServiceLocator.get('apiClient');
    const method = 'getMatchesByIds';

    return apiClient.makeRequest({
        method,
        variables,
    });
}
